module.exports = __webpack_public_path__ + "img/vi_vn.f04699b8.png";